import Layout from "../../../design-system/components/Layout/Layout.jsx";
import tokens from "../../../design-system/tokens.js";
import { ShellContent } from "../../shell/Shell.jsx";
import { ShowroomHeader } from "./components/ShowroomHeader/ShowroomHeader.jsx";
import styles from "./ShowroomEntries.css.ts";
import { ShowroomEntries } from "./ShowroomEntries.jsx";

/**
 * Renders a showroom overview with data.
 *
 * @param {object} SparkShowroomOverviewWithData - Object containing data for the showroom overview.
 * @param {array} SparkShowroomOverviewWithData.entries - Array of entries for the showroom.
 * @param {array} SparkShowroomOverviewWithData.otherSharedEntries - Array of other shared entries.
 * @param {object} SparkShowroomOverviewWithData.unseenByEntryId - Object containing unseen entries by ID.
 * @param {object} SparkShowroomOverviewWithData.workshopSettings - Workshop settings.
 * @param {boolean} SparkShowroomOverviewWithData.hasExistingShowroomEntry - Indicates whether the user has already uploaded a showroom entry.
 * @param {string} SparkShowroomOverviewWithData.publicShowroomButtonTarget - Target URL for the public showroom button.
 * @param {string} SparkShowroomOverviewWithData.uploadEditButtonTarget - Target URL for the upload/edit button.
 * @return {JSX.Element} - The rendered showroom overview component.
 */
export const SparkShowroomOverviewWithData = ({
  entries,
  otherSharedEntries = [],
  unseenByEntryId = [],
  workshopSettings,
  hasExistingShowroomEntry = false,
  publicShowroomButtonTarget,
  uploadEditButtonTarget,
}) => {
  return (
    <ShellContent bg={tokens.color.full.gray800}>
      <Layout
        Header={() => (
          <ShowroomHeader
            isDarkMode={true}
            hasExistingShowroomEntry={hasExistingShowroomEntry}
            publicShowroomButtonTarget={publicShowroomButtonTarget}
            uploadEditButtonTarget={uploadEditButtonTarget}
          />
        )}
        isDarkMode={true}
      >
        {entries.length === 0 ? (
          <div className={styles.text}>
            <p>Noch keine Projekte</p>
            <p>
              Über die Hochladen-Funktion kannst du ein Projekt zum Showroom
              hinzufügen.
            </p>
          </div>
        ) : (
          <ShowroomEntries
            entries={entries}
            workshopSettings={workshopSettings}
            unseenByEntryId={unseenByEntryId}
          />
        )}

        {otherSharedEntries.length > 0 && (
          <section>
            <h2 className={styles.otherEntriesHeading}>
              Projekte anderer Lernreisen
            </h2>
            <ShowroomEntries
              entries={otherSharedEntries}
              workshopSettings={workshopSettings}
              unseenByEntryId={unseenByEntryId}
            />
          </section>
        )}
      </Layout>
    </ShellContent>
  );
};
